export default __webpack_public_path__ + "static/media/video_purple.85b32661.svg";